export default (values) => {
  const errors = {};

  if(!values.get('username')) {
    errors.username = 'login:username_required';
  }

  if(!values.get('password')) {
    errors.password = 'login:password_required';
  }

  if(!values.get('newPassword')) {
    errors.newPassword = 'login:new_password_required';
  }

  if(!values.get('mfaCode')) {
    errors.mfaCode = 'login:mfa_code_required';
  }

  return errors;
};



// export const usernameRequired = value => (value ? undefined : 'login:username_required');
// export const passwordRequired = value => (value ? undefined : 'login:password_required');
// export const newpassWordRequired = value => (value ? undefined : 'login:new_password_required');
// export const mfaSectionRequired = value => (value ? undefined : 'login:mfa_code_required');




// WEBPACK FOOTER //
// ./src/login/validate.js